import { useQuery } from '@tanstack/react-query';
import { PerformanceService } from '../services/performance.service';
import type { PerformanceFilters } from '../types/performance.types';
import { useState } from 'react';

export function useConstructionPerformance(companyId: string, initialFilters: PerformanceFilters = {}) {
  const [filters, setFilters] = useState<PerformanceFilters>(initialFilters);

  const snapshotsQuery = useQuery({
    queryKey: ['performance-snapshots', companyId, filters],
    queryFn: () => PerformanceService.getSnapshots(companyId, filters),
    enabled: !!companyId,
  });

  const liveKpisQuery = useQuery({
    queryKey: ['performance-live-kpis', companyId, filters.projectId],
    queryFn: () => PerformanceService.getLiveKpis(companyId, filters.projectId!),
    enabled: !!companyId && !!filters.projectId,
  });

  return {
    snapshots: snapshotsQuery.data || [],
    liveKpis: liveKpisQuery.data,
    isLoading: snapshotsQuery.isLoading || liveKpisQuery.isLoading,
    filters,
    setFilters
  };
}

export function usePerformanceAlerts(companyId: string, projectId: string) {
  return useQuery({
    queryKey: ['performance-alerts', companyId, projectId],
    queryFn: () => PerformanceService.getAlerts(companyId, projectId),
    enabled: !!companyId && !!projectId,
  });
}
